/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, ElementRef, EventEmitter, NgZone, Output } from "@angular/core";
import { ɵNzTabScrollListDirective } from "ng-zorro-antd/tabs";
import { UiTabScrollEvent, UiTabScrollListOffsetEvent } from "../models/tab.models";

@Directive({
  selector: "[uiTabScrollList]",
})
export class UiTabScrollListDirective extends ɵNzTabScrollListDirective {
  @Output() public readonly offsetChange = new EventEmitter<UiTabScrollListOffsetEvent>();
  @Output() public readonly tabScroll = new EventEmitter<UiTabScrollEvent>();

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  public constructor(ngZone: NgZone, elementRef: ElementRef<HTMLElement>) {
    super(ngZone, elementRef);
  }
}
